"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("../config");
function default_1(delta) {
    if (Math.abs(delta) < config_1.default.minDelta) {
        return 100;
    }
    var syncPerc = (Math.abs(delta) * 100) / config_1.default.maxDelta;
    if (syncPerc > 100) {
        return 0;
    }
    else {
        var res = 100 - syncPerc;
        return parseInt(res.toString(), 10);
    }
}
exports.default = default_1;
//# sourceMappingURL=calculateAccuracy.js.map